import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'type' })
export class TypePipe implements PipeTransform {
    transform(value: any) {
        const type = typeof (value);
        if (type === 'object') {
            return Array.isArray(value) ? 'array' : 'object';
        }

        return type;
    }
}
